
















































import { Component, Vue, Prop } from "vue-property-decorator";
import eventDetailBox from "@/components/eventDetailBox.vue";

@Component({
  name: "inspeAccountList",
  components: {
    "v-eventDetailBox": eventDetailBox
  }
})
export default class extends Vue {
  @Prop()
  private eventList: any;
  private eventItem: any = "";
  private total: number = 0;
  private orgId(item: any) {
    this.eventItem = item;
    (this as any).$refs.eventDetailBox.dialogTableVisible = true;
  }

  private pageChange(page: number) {
    this.$emit("pageChange", page);
  }

  private cellClass({ row, column, rowIndex, columnIndex }: any) {
    if (columnIndex === 2) {
      return "one-line";
    }
  }
}
